import { render, staticRenderFns } from "./InvoiceSummary.vue?vue&type=template&id=1dd8759c&scoped=true&"
import script from "./InvoiceSummary.vue?vue&type=script&lang=js&"
export * from "./InvoiceSummary.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSummary.vue?vue&type=style&index=0&id=1dd8759c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8759c",
  null
  
)

export default component.exports